module.exports = __webpack_public_path__ + "img/novakid_start.f2c3e8f3.png";